import React, { useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { python } from "@codemirror/lang-python";
import Sk from "skulpt";

const PythonCodeEditorTerminal = () => {
  const [code, setCode] = useState("print('Hello from Python')");
  const [output, setOutput] = useState("");

  const runCode = () => {
    let result = "";
    function outf(text) {
      result += text;
    }
    Sk.configure({ output: outf });
    Sk.misceval
      .asyncToPromise(() => Sk.importMainWithBody("<stdin>", false, code, true))
      .then(() => setOutput(result))
      .catch((err) => setOutput(err.toString()));
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div style={{ flex: 1, position: "relative" }}>
        <button
          onClick={runCode}
          style={{
            position: "absolute",
            top: "10px",
            right: "30px",
            zIndex: 10,
            padding: "10px 20px",
            background: "#333",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Run ▶
        </button>
        <CodeMirror
          value={code}
          height="82vh"
          extensions={[python()]}
          onChange={setCode}
        />
      </div>
      <div
        style={{
          flex: 1,
          background: "#1e1e1e",
          color: "#fff",
          padding: "10px",
        }}
      >
        <h4>Output:</h4>
        <pre>{output}</pre>
      </div>
    </div>
  );
};

export default PythonCodeEditorTerminal;
